import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Skeleton } from '@hh.ru/magritte-ui-skeleton';
import { s as styles } from './progress-bar-CO7jmyT5.js';

const ProgressBarSkeleton = ({ Component: ProgressBar, 
// skeleton props
width, height, borderRadius, inline, additionalClass, loading, ...progressBarProps }) => (jsx(Skeleton, { loading: loading, additionalClass: styles.progressSkeleton, children: jsx(ProgressBar, { ...progressBarProps }) }));

export { ProgressBarSkeleton };
//# sourceMappingURL=Skeleton.js.map
